var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search',{attrs:{"getData":_vm.getData,"handleOptions":_vm.handleOptions}}),_c('List',{attrs:{"page":_vm.branchPage,"handleOptions":_vm.handleOptions,"getData":_vm.getData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }